<i *ngIf="tooltip" [pTooltip]="tooltip" class="pi pi-info-circle hint-icon"></i>
